import { QueryResult } from '@apollo/client';
import { TCommonRecommenderItem } from 'components/domain/fdr-page-components/fdr-page-components.types';
import { mapRecommenderProduct } from 'components/domain/fdr-page-components/fdr-page-components.utils';
import { IFdrProductRecommenderProduct } from 'components/domain/fdr-page-components/recommenders/product/fdr-product-recommender.types';
import { isFdrThProduct } from 'components/domain/fdr-product/fdr-product.utils';
import {
  FdrThemeGeoPaginatedProductsQuery,
  FdrThemeGeoPaginatedProductsQueryVariables,
} from 'schemas/query/theme-geo/fdr-theme-geo-paginated-products.generated';
import {
  FdrThemeGeoPaginatedThemeGeoQuery,
  FdrThemeGeoPaginatedThemeGeoQueryVariables,
} from 'schemas/query/theme-geo/fdr-theme-geo-paginated-theme-geo.generated';

export const mapThemeGeoProductResponseToProducts = (
  data: QueryResult<
    FdrThemeGeoPaginatedProductsQuery,
    FdrThemeGeoPaginatedProductsQueryVariables
  >
): IFdrProductRecommenderProduct[] => {
  return (
    data?.data.fdrThemeGeoPage?.page?.themeGeoProducts.products
      ?.filter(isFdrThProduct)
      .map(mapRecommenderProduct) || []
  );
};

export const mapThemeGeoRecommenderResponseToThemeGeo = (
  data: QueryResult<
    FdrThemeGeoPaginatedThemeGeoQuery,
    FdrThemeGeoPaginatedThemeGeoQueryVariables
  >['data']
): TCommonRecommenderItem[] => {
  return (
    data?.fdrThemeGeoPage?.page?.themeGeoPagesRecommender?.themeGeoPages?.map(
      i => ({
        ...i,
        id: [i.geo.id, i.theme.id].join('-'),
        link: i.webMeta.link,
      })
    ) || []
  );
};
